// Microsoft Clarity Project ID - set NEXT_PUBLIC_CLARITY_PROJECT_ID in .env.local to enable
export const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID || 'xwxmk9tzo7';
